import { Injectable } from '@angular/core'
import { FieldModel } from './field/field.model'
import { FormyModel } from './formy.model'
import { AjaxService } from 'src/app/shared/ajax.service'
import { CmodalService } from '../cmodal/cmodal.service'
import { PipsPipe } from '../../shared/pips.pipe'
import { GridService } from '../grid/grid.service'
import { UtilService } from 'src/app/shared/util.service'
import { AlerterService } from 'src/app/shared/alerter.service'
import { LoadOptModel, LoadFltModel } from '../grid/grid.model';

@Injectable({
  providedIn: 'root'
})
export class FormyService {
  components: any[]

  constructor(private util: UtilService, private gservice: GridService, private cmodalService: CmodalService, private pip: PipsPipe, private alerter: AlerterService, private ajax: AjaxService) {
    this.components = []
  }

  onInit() { 
   

  }

  clear(model: FormyModel) {
    for (let fld of model.flds)
      fld.val = fld.val2
  }

  load_dep(model: FormyModel, row_id: string, grid_id: string) {
    this.ajax.execute({
      url: 'formy/load',
      data: { id: model.id, row_id, grid_id },
      success: (post: any) => {
        if (!post.result || post.result.length == 0) { this.alerter.warning('اطلاعات دریافت نشد'); return }
        this.util.replacer(post.result, [null], '∅')
        for (let fld of model.flds) {
          switch (fld.cmp) {
            case 6:
              if (fld.cnf.typ == 1) fld.val = this.pip.date(post.result[0][fld.nam]).toString()// v.format('jYYYY-jMM-jDD')
              if (fld.cnf.typ == 2) fld.val = this.pip.time(post.result[0][fld.nam])
              if (fld.cnf.typ == 3) fld.val = this.pip.datetime(post.result[0][fld.nam])
              if (fld.cnf.typ == 4) fld.val = this.pip.month(post.result[0][fld.nam]).toString()
              break
            default: fld.val = post.result[0][fld.nam]
          }
        }
      }
    })
  }

  submit_dep(model: FormyModel) {
    var flds = []
    var val: any

    for (let item of model.flds) {
      val = item.val
      if (item.cmp == 6)
        if (typeof val == 'object') val = val.format('jYYYYjMMjDD')
        else if (typeof val == 'string') val = val.split('-').join('')
      flds.push({ nam: item.nam, val })
    }

    var data = { id: model.id, flds: flds, iem: model.dyn.iem, grid_id: model.dyn.grid_id, row_id: null }
    if (model.dyn.iem != 'true')
      data.row_id = model.dyn.row_id
    this.util.replacer(data, [null], '∅')
    this.ajax.execute({
      url: 'formy/insdate',
      data: data,
      success: (post: any) => {
        // this.gservice.update_row(data.grid_id, data.row_id, post.result, flds)
        let model_grid = this.gservice.components.find(x => x.model.id == data.grid_id).model
        let flts: LoadFltModel[] = []
        flts.push({ als: 'id', val: data.row_id, mod: 1 })
        this.gservice.load(model_grid, flts, null, null, (dat: any) => {
          for (let u = 0; u < model_grid.dats.length; u++)
            if (model_grid.dats[u][0] == dat[0][0]) {
              model_grid.dats[u] = dat[0]
              break
            }
          for (let u = 0; u < model_grid.dats_vis.length; u++)
            if (model_grid.dats_vis[u][0] == dat[0][0]) {
              model_grid.dats_vis[u] = dat[0]
              break
            }
        })
        this.cmodalService.unimplement()
      }
    })
  }

  cancel_dep(model: FormyModel) {
    this.cmodalService.unimplement()

  }

  // ------- fields ------------------------------------------
  grd(siz: number) {
    return `col col-xl-${2 * siz} col-lg-${3 * siz} col-md-${4 * siz} col-sm-${6 * siz} col-xs-12`;
  }

  // ------- utilities ---------------------------------------
  switch_cmptyp(cmp: number, typ: any): any {
    if (cmp == 2)
      switch (typ) {
        case 1: return 'text';
        case 2: return 'number';
        case 3: return 'email';
        case 4: return 'password';
        case 5: return 'color';
        case "text": return 1;
        case "number": return 2;
        case "email": return 3;
        case "password": return 4;
        case "color": return 5;
      }

    if (cmp == 6)
      switch (typ) {
        case 1: return 'day';
        case 2: return 'time';
        case 3: return 'daytime';
        case 4: return 'month';
        case "day": return 1;
        case "time": return 2;
        case "daytime": return 3;
        case "month": return 4;
      }
  }
}
